import ED from './bluestone/ED';
import GO from './bluestone/GO';
import OP from './bluestone/OP';
import TR from './bluestone/TR';
import COBALT_ED from './cobalt/ED';
import COBALT_GO from './cobalt/GO';
import COBALT_OP from './cobalt/OP';
import COBALT_TR from './cobalt/TR';

const themes = {
  ED,
  GO,
  OP,
  TR,
  COBALT_ED,
  COBALT_GO,
  COBALT_OP,
  COBALT_TR,
};

export { themes };
